var React = require('react');

function PadlockIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"style":{"fill":"none","stroke":"#fff","strokeWidth":"25","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10"}},[React.createElement("path",{"d":"m399.3 483h-299.5c-8.8 0-16-7.2-16-16v-255.1h331.4v255.1c.1 8.9-7.1 16-15.9 16z","key":0}),React.createElement("path",{"d":"m219.4 350.9v41.7c0 16.6 13.6 30.1 30.1 30.1 16.6 0 30.1-13.6 30.1-30.1v-41.7c9.2-8.3 15.1-20.3 15.1-33.6 0-25-20.2-45.2-45.2-45.2s-45.2 20.2-45.2 45.2c0 13.4 5.9 25.4 15.1 33.6z","key":1}),React.createElement("path",{"d":"m136.6 211.9v-82.9c0-62.1 50.8-113 113-113 62.1 0 113 50.8 113 113","key":2})]));
}

PadlockIconInline.defaultProps = {"enableBackground":"new 0 0 500 500","viewBox":"0 0 500 500"};

module.exports = PadlockIconInline;

PadlockIconInline.default = PadlockIconInline;
